import {
  IS_LOADING, RESULT_BY, SET_RELOADED_TIME, SET_SECTOR, SET_TABLE_DATA,
} from '../../redux/HotStocks/ActionTypes';
import { message } from 'antd';
import axiosOrder from '../../axios';

const reducer = (state = {
  viewBy: 1, tableData: [], sector: 'All', loading: false, reloadedTime: '',
},
action: { type: string; data: string; }) => {
  switch (action.type) {
  case RESULT_BY:
    return {
      ...state,
      loading: false,
      viewBy: action.data,
    }
  case  SET_RELOADED_TIME:
    return {
      ...state,
      reloadedTime: action.data,
    }
  case SET_TABLE_DATA:
    return {
      ...state,
      tableData: action.data,
    }
  case SET_SECTOR:
    return {
      ...state,
      loading: false,
      sector: action.data,
    }
  case IS_LOADING:
    return {
      ...state,
      loading: action.data,
    }
  default:
    return state;
  }
}
const Loading = (loading: boolean) => ({ type: IS_LOADING, data: loading })
const setHotStocksData = (response: any) => ({ type: SET_TABLE_DATA, data: response });
const setHotStocksReloadedTime = (data: string) => ({ type: SET_RELOADED_TIME, data });
export const loadHotStock = (sector: string, resultBy: string) => async (dispatch: (data: any) => void) => {
  try {
    dispatch(Loading(true));
    const { data: { data, reloadedTime } } = await axiosOrder.get('/systemx/dalalstreet/hotStocks', {
      params: {
        sector,
        date: resultBy,
      },
    })
    dispatch(setHotStocksData(data));
    dispatch(setHotStocksReloadedTime(reloadedTime));
    dispatch(Loading(false));
  } catch (ex) {
    message.error('Cannot load hot stocks. Try again');
    dispatch(Loading(false));
  }
}
export default reducer;



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/HotStocks/Actions.ts